// window.Mobile = Variável global setada pelo app Android na webview
// window.webkit = Variável global setada pelo app IOS

const ANDROID = 'android'
const IOS = 'ios'
const RETURN_ACCOUNT = 'account'

const isiOSChrome = navigator.userAgent.match(/CriOS/i) !== null
const getAppType = () => (window.Mobile ? ANDROID : IOS)
const isInApp = () => window.Mobile || (window.webkit && !isiOSChrome)

const dispatchToMobile = type => {
  const appType = getAppType()
  switch (type) {
    case RETURN_ACCOUNT:
      appType === IOS
        ? window.webkit.messageHandlers.returnAccount.postMessage('account')
        : window.Mobile.returnAccount && window.Mobile.returnAccount(null)
      break
    default:
      appType === IOS
        ? window.webkit.messageHandlers.returnHome.postMessage('home')
        : window.Mobile.returnHome && window.Mobile.returnHome(null)
  }
}

export { dispatchToMobile, isInApp, RETURN_ACCOUNT }
